import { useContext } from 'react'

import { Box, Checkbox, FormControlLabel, TextField } from '@material-ui/core'
import { CONTENT_TYPES } from '@scoir/college-content'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const Location = (): JSX.Element | null => {
  const { item, onUpdateField, type } = useContext(ContentModalContext)

  const displayHelperText = type === CONTENT_TYPES.SESSIONS
  const value = item[FIELD_NAMES.LOCATION]
  const checked = item[FIELD_NAMES.ROOM_BOARD]
  const isVirtual = item[FIELD_NAMES.IS_VIRTUAL]

  return isVirtual ? null : (
    <div>
      <TextField
        id={FIELD_NAMES.LOCATION}
        fullWidth
        variant="outlined"
        label="Location"
        placeholder="Location"
        value={value}
        helperText={displayHelperText ? 'This helps users find nearby events' : undefined}
        onChange={(e) => onUpdateField(FIELD_NAMES.LOCATION, e.target.value)}
      />
      {type === CONTENT_TYPES.PROGRAMS && (
        <Box
          ml={1.5}
          mt={3}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                color="primary"
                onChange={(e) => onUpdateField(FIELD_NAMES.ROOM_BOARD, e.target.checked)}
                name={FIELD_NAMES.ROOM_BOARD}
              />
            }
            label={LABELS.ROOM_BOARD}
          />
        </Box>
      )}
    </div>
  )
}

export default Location
